import { GenericResponse } from "./generic-response";
import { ObjectType } from "./object-type";
import { PermissionMode } from "./permission-mode";
import { PermissionType } from "./permission-type";

// #region External access types

export enum ExternalAccessStatus {
  Pending = "Pending",
  Active = "Active",
  Expired = "Expired",
  Revoked = "Revoked",
}

export interface ExternalAccessDto {
  id: number;
  objectId: number;
  ownerId: number;
  userId: number;
  email: string;
  expirationDate: string;
  permissions: PermissionType[];
  status: ExternalAccessStatus;
  createdAt: Date;
  objectType: ObjectType | null;
  objectName: string | null;
  objectChildCount: number | null;
  updatedAt: Date | null;
}

export interface CreateExternalAccessRequest {
  virtualHeadName: string;
  objectIds: number[];
  emails: string[];
  expirationDate: Date;
  emailSubject: string | null;
  emailMessage: string | null;
  permissions: PermissionType[];
}

export interface ValidateExternalAccessRequest {
  key: string;
  firstName: string;
  lastName: string;
}

export interface UpdateExternalAccessRequest {
  id: number;
  permissions: PermissionType[];
  expirationDate: Date;
}

export interface ListExternalAccessesResponse extends GenericResponse<ListExternalAccessesResponse> {
  accesses: ExternalAccessDto[];
}

export interface GetExternalAccessResponse extends GenericResponse<GetExternalAccessResponse> {
  access: ExternalAccessDto;
}

export interface GetExternalAccessNoAuthResponse extends GenericResponse<GetExternalAccessNoAuthResponse> {
  platformId: number;
  email: string;
  creatorName: string;
  daysTillExpiration: number;
  cofRequired: boolean;
  firstName: string | null;
  lastName: string | null;
}
// #endregion External access types

// #region Components types
// User access
export interface AccessUserInfos {
  id: number;
  groupId: number;
  firstName: string;
  lastName: string;
}

export interface AccessGroupInfos {
  id: number;
  name: string;
  count: number;
}

export interface PermissionByMode {
  permission: PermissionType;
  mode: PermissionMode;
}

export type PermissionCombination = PermissionByMode[];

export interface UsersAndGroupsByPermissionCombination {
  permissionCombination: PermissionCombination;
  users: AccessUserInfos[];
  groups: AccessGroupInfos[];
}
// #endregion Components types
